export default {
  board_type: [
    {value: 0, text: 'Lista', icon: 'view_list'},
    {value: 1, text: 'Tabela', icon: 'table_chart'},
    {value: 2, text: 'Kanban', icon: 'vertical_split'},
    {value: 3, text: 'Dashboard', icon: 'dashboard'}
  ],
  connection_status: [
    {value: 1, text: 'Aguardando', color: 'amber lighten-2', icon: 'lens'},
    {value: 2, text: 'Conectado', color: 'green', icon: 'check_circle'},
    {value: 3, text: 'Não Conectado', color: 'pink', icon: 'cancel'}
  ],
  connection_type_person: [
    {value: 1, text: 'Pessoa Física'},
    {value: 2, text: 'Pessoa Jurídica'}
  ],
  reminder_indicator: [
    {value: 1, text: 'Minutos'},
    {value: 2, text: 'Horas'},
    {value: 3, text: 'Dias'},
    {value: 4, text: 'Semanas'},
    {value: 5, text: 'Meses'}
  ],
  reminder_type: [
    {value: 1, text: 'E-mail'},
    {value: 2, text: 'WhatsApp'}
  ],
  task_urgency: [
    {value: 1, text: 'Não Urgente', color: 'blue lighten-2', color_solid: 'blue'},
    {value: 2, text: 'Pouco Urgente', color: 'green lighten-3', color_solid: 'green'},
    {value: 3, text: 'Urgente', color: 'orange lighten-2', color_solid: 'orange'},
    {value: 4, text: 'Emergente', color: 'red lighten-3', color_solid: 'red'}
  ],
  emails: [
    {value: 1, text: 'Convite'},
    {value: 2, text: 'Resumo'}
  ],
  message_urgency: [
    {value: 1, text: 'Não Urgente'},
    {value: 2, text: 'Pouco Urgente'},
    {value: 3, text: 'Urgente'},
    {value: 4, text: 'Emergente'}
  ],
  user_gender: [
    {value: 'F', text: 'Feminino'},
    {value: 'M', text: 'Masculino'}
  ],
  file_source: [
    {value: 1, text: 'Arquivo'},
    {value: 2, text: 'Tarefa'}
  ],
  chat_room_type: [
    {value: 1, text: 'Empresa'},
    {value: 2, text: 'Participantes da empresa'},
    {value: 3, text: 'Equipes'},
    {value: 4, text: 'Parceiros'}
  ],
  company_segments: [
    {segment_id: 1, id_text: 'Advocacia'},
    {segment_id: 2, id_text: 'Agronegócio'},
    {segment_id: 3, id_text: 'BPO'},
    {segment_id: 4, id_text: 'Construção civil'},
    {segment_id: 5, id_text: 'Consultoria'},
    {segment_id: 6, id_text: 'Contabilidade'},
    {segment_id: 14, id_text: 'Distribuidora'},
    {segment_id: 7, id_text: 'Estudos'},
    {segment_id: 15, id_text: 'Fábrica/Indústria'},
    {segment_id: 16, id_text: 'Loja/Comércio'},
    {segment_id: 8, id_text: 'Marketing'},
    {segment_id: 9, id_text: 'Imobiliária'},
    // {segment_id: 10, id_text: 'Projetos'},
    // {segment_id: 11, id_text: 'Tarefas domésticas'},
    // {segment_id: 12, id_text: 'Tarefas e afazeres'},
    {segment_id: 17, id_text: 'Prestador de serviços'},
    {segment_id: 18, id_text: 'Saúde'},
    {segment_id: 13, id_text: 'TI'},
    {segment_id: 0, id_text: 'Outros'}
  ],
  company_search: [
    {search_id: 1, id_text: 'Agenda compartilhada'},
    {search_id: 2, id_text: 'Atendimento ao cliente'},
    {search_id: 3, id_text: 'Controle de compras'},
    {search_id: 4, id_text: 'Controle de estoque'},
    {search_id: 5, id_text: 'Controle financeiro'},
    {search_id: 6, id_text: 'Controle de tarefas pessoais'},
    {search_id: 7, id_text: 'Emissão de notas fiscais'},
    {search_id: 8, id_text: 'Gestão de equipes externas'},
    {search_id: 9, id_text: 'Gestão da equipe de vendas'},
    {search_id: 10, id_text: 'Gestão de manutenção'},
    {search_id: 11, id_text: 'Gestão de ordem de serviços'},
    {search_id: 12, id_text: 'Gestão de projetos'},
    {search_id: 13, id_text: 'Processo de produção'},
    {search_id: 14, id_text: 'Recrutamento e aquisição de talentos'},
    {search_id: 15, id_text: 'Rotina de trabalho da minha equipe'},
    {search_id: 0, id_text: 'Outros'}
  ],

  company_size: [
    {value: '1 - 2', text: '1 - 2'},
    {value: '3 - 5', text: '3 - 5'},
    {value: '6 - 10', text: '6 - 10'},
    {value: '11 - 20', text: '11 - 20'},
    {value: '21 - 50', text: '21 - 50'},
    {value: '51 - 100', text: '51 - 100'},
    {value: '101 - 200', text: '101 - 200'},
    {value: 'Acima de 200', text: 'Acima de 200'}
  ],
  company_user_status: [
    {value: 1, text: 'Aguardando'},
    {value: 2, text: 'Aceito'},
    {value: 3, text: 'Recusado'}
  ],
  company_type_person: [
    {value: 1, text: 'Pessoa Física'},
    {value: 2, text: 'Pessoa Jurídica'}
  ],
  mention_notification: [
    {value: 1, text: 'Notificação Pop-Up'},
    {value: 2, text: 'E-mail'},
    {value: 3, text: 'WhatsApp'}
  ],
  field_options: [
    {value: 1, type: 'number', title: 'Número'},
    {value: 2, type: 'value', title: 'Valor'},
    {value: 3, type: 'string', title: 'Texto'},
    {value: 4, type: 'select', title: 'Seleção'},
    {value: 7, type: 'multiselect', title: 'Múltipla seleção'},
    {value: 5, type: 'date', title: 'Data'},
    {value: 6, type: 'files', title: 'Arquivos'},
    {value: 8, type: 'phone', title: 'Telefone'},
    {value: 9, type: 'email', title: 'E-mail'}
    // {value: 7, type: 'multiselect', title: 'Seleção'},
  ],
  payment_status: [
    {value: 'PENDING', type: 'asaas', text: 'Aguardando pagamento'},
    {value: 'RECEIVED', type: 'asaas', text: 'Recebido'},
    {value: 'CONFIRMED', type: 'asaas', text: 'Pagamento confirmado'},
    {value: 'OVERDUE', type: 'asaas', text: 'Vencida Pago'},
    {value: 'REFUNDED', type: 'asaas', text: 'Estornada'},
    {value: 'RECEIVED_IN_CASH', type: 'asaas', text: 'Recebida em dinheiro'},
    {value: 'REFUND_REQUESTED', type: 'asaas', text: 'Estorno Solicitado'},
    {value: 'CHARGEBACK_REQUESTED', type: 'asaas', text: 'Recebido chargeback como Pago'},
    {value: 'CHARGEBACK_DISPUTE', type: 'asaas', text: 'Em disputa de chargeback'},
    {value: 'AWAITING_CHARGEBACK_REVERSAL', type: 'asaas', text: 'Disputa vencida, aguardando repasse da adquirente'},
    {value: 'DUNNING_REQUESTED', type: 'asaas', text: 'Em processo de recuperação'},
    {value: 'DUNNING_RECEIVED', type: 'asaas', text: 'Recuperada'},
    {value: 'AWAITING_RISK_ANALYSIS', type: 'asaas', text: 'Pagamento em análise'},
    // CANCELED criado pelo illis
    {value: 'CANCELED', type: 'asaas', text: 'Cancelado'}
  ],
  subscription_status: [
    {value: 'NEW', text: 'Nova'},
    {value: 'ACTIVE', text: 'Ativa'},
    {value: 'EXPIRED', text: 'Expirado'},
    // NEW e CANCELED criado pelo illis
    {value: 'CANCELED', text: 'Cancelado'}
  ],
  payment_method: [
    {value: 'CREDIT_CARD', text: 'Cartão de crédito'},
    {value: 'BOLETO', text: 'Boleto bancário'}
  ],
  // PAgseguro
  // * 1 = Aguardando pagamento
  // * 2 = Em análise (Ainda não Aprovado)
  // * 3 = Paga (Aprovada)
  // * 4 = Disponível (Dinheiro disponível para fazer saque)
  // * 5 = Em disputa (Usuário solicitou disputa)
  // * 6 = Devolvida (Disputa aprovada e dinheiro devolvido pro usuário)
  // * 7 = Cancelada (Processou e não foi foi aprovada)
  // * 8 = Debitado (Usuário já raecebeu dinheiro da disputa)
  // * 9 = Retenção Temporária = Chargeback (Usuário abriu disputa diretamente com o cartão)
  // Mercado pago
  /*
    Possíveis tipo de status
    pending = Em análise
    approved = Aprovado
    in_process = Em Evnisão
    in_mediation = Em processo de disputa
    rejected = Foi rejeitado
    cancelled = Foi cancelado
    refounded = Reembolsado
    charged_back = Chargeback (Liga pro cartão e não reconhece a compra)
  */
  payment_type: [
    {value: 'pagseguro', text: 'PagSeguro'},
    {value: 2, text: 'teste2'},
    {value: 3, text: 'teste3'}
  ],
  week_days: [
    { value: 0, text: 'Domingo' },
    { value: 1, text: 'Segunda' },
    { value: 2, text: 'Terça' },
    { value: 3, text: 'Quarta' },
    { value: 4, text: 'Quinta' },
    { value: 5, text: 'Sexta' },
    { value: 6, text: 'Sábado' }
  ],
  task_order_by: [
    { value: 'created_at', text: 'Data de Criação' },
    { value: 'client.id_text', text: 'Cliente' },
    { value: 'id_text', text: 'Descrição' },
    { value: 'team.id_text', text: 'Equipe' },
    { value: 'identifier', text: 'ID' },
    { value: 'company.id_text', text: 'Origem' },
    { value: 'end', text: 'Data de Previsão' },
    { value: 'user.id_text', text: 'Responsável' },
    { value: 'status.id_text', text: 'Status' },
    { value: 'urgency', text: 'Urgência' },
    { value: 'status_update', text: 'Alteração de Status' },
    { value: 'updated_at', text: 'Alteração de Tarefa' }
  ],
  task_filter_level: [
    { value: 1, text: 'Listar tarefas' },
    { value: 2, text: 'Listar subtarefas' },
    { value: 0, text: 'Listar tarefas e subtarefas' }
  ],
  months: [
    { value: 1, text: 'Janeiro' },
    { value: 2, text: 'Fevereiro' },
    { value: 3, text: 'Março' },
    { value: 4, text: 'Abril' },
    { value: 5, text: 'Maio' },
    { value: 6, text: 'Junho' },
    { value: 7, text: 'Julho' },
    { value: 8, text: 'Agosto' },
    { value: 9, text: 'Setembro' },
    { value: 10, text: 'Outubro' },
    { value: 11, text: 'Novembro' },
    { value: 12, text: 'Dezembro' }
  ],
  dashboard_card_type: [
    { value: 1, text: 'Tabela' },
    { value: 2, text: 'Barra' },
    { value: 3, text: 'Pizza' }
  ],
  dashboard_date_type: [
    { value: 'datetime', text: 'Data Hora' },
    { value: 'daily', text: 'Diário' },
    { value: 'weekly', text: 'Semanal' },
    { value: 'monthly', text: 'Mensal' },
    { value: 'anualy', text: 'Anual' }
  ],
  dashboard_date_status: [
    { value: '', text: 'Todas' },
    { value: 'late', text: 'Atrasada' },
    { value: 'on_time', text: 'No prazo' }
  ],
  dashboard_fields_table: [
    { value: 'task', text: 'Tarefa', category: 'task', type: 'text' },
    { value: 'task_status', text: 'Status', category: 'join_task', type: 'text' },
    { value: 'urgency_id', text: 'Urgência', category: 'urgency', type: 'text' },
    { value: 'begin', text: 'Data de Início', category: 'field_task', type: 'datetime' },
    { value: 'end', text: 'Data de Previsão', category: 'field_task', type: 'datetime' },
    { value: 'teams', text: 'Equipe', category: 'join_task', type: 'text' },
    { value: 'users', text: 'Responsável da tarefa', category: 'join_task', type: 'text' },
    { value: 'client', text: 'Cliente', category: 'join_task', type: 'text' },
    { value: 'task_category', text: 'Categoria', category: 'join_task', type: 'text' },
    { value: 'duration_user', text: 'Reponsável da duração', category: 'duration', type: 'text' },
    { value: 'durations', text: 'Durações', category: 'duration', type: 'time', aggregate_function: 'SUM' },
    { value: 'task_template', text: 'Tarefa Modelo', category: 'tasktemplate', type: 'text' }
  ],
  tasktemplate_form_fields: [
    // { id: 'task', title: 'Tarefa', type: 'string' },
    // { id: 'task_status', title: 'Status', type: 'string' },
    // { id: 'urgency_id', title: 'Urgência', type: 'string' },
    // { id: 'begin', title: 'Data de Início', type: 'datetime' },
    // { id: 'end', title: 'Data de Previsão', type: 'datetime' },
    // { id: 'teams', title: 'Equipe', type: 'string' },
    { id: 'user', title: 'Responsável da tarefa', type: 'select' },
    { id: 'client', title: 'Cliente', type: 'select' }
    // { id: 'task_category', title: 'Categoria', type: 'string' },
    // { id: 'duration_user', title: 'Reponsável da duração', type: 'string' },
    // { id: 'durations', title: 'Durações', type: 'time', aggregate_function: 'SUM' },
    // { id: 'task_template', title: 'Tarefa Modelo', type: 'string' }
  ],
  tasktemplate_document: [
    { id: 'identifier_sequence', title: 'ID', category: 'field_task', type: 'text' },
    { id: 'id_text', title: 'Descrição', category: 'field_task', type: 'text' },
    { id: 'begin', title: 'Data de início', category: 'field_task', type: 'datetime' },
    { id: 'end', title: 'Data de previsão', category: 'field_task', type: 'datetime' },
    { id: 'status', title: 'Status', category: 'join_task', type: 'text' },
    { id: 'urgency', title: 'Urgência', category: 'field_task', type: 'text' },
    { id: 'team', title: 'Equipe', category: 'join_task', type: 'text' },
    { id: 'user', title: 'Responsável', category: 'join_task', type: 'text' },
    { id: 'category', title: 'Categoria', category: 'join_task', type: 'text' },
    { id: 'note', title: 'Observação', category: 'field_task', type: 'text' },
    { id: 'checklist', title: 'Listagem', category: 'join_task', type: 'text' },
    { id: 'identifier', title: 'ID', category: 'field_client', type: 'text' },
    { id: 'id_text', title: 'Nome', category: 'field_client', type: 'text' },
    { id: 'country', title: 'País', category: 'field_client', type: 'text' },
    { id: 'state', title: 'Estado', category: 'field_client', type: 'text' },
    { id: 'city', title: 'Cidade', category: 'field_client', type: 'text' },
    { id: 'cpfcnpj', title: 'CPF/CNPJ', category: 'field_client', type: 'cpfcnpj' },
    { id: 'rgie', title: 'RG/IE', category: 'field_client', type: 'text' },
    { id: 'address', title: 'Endereço', category: 'field_client', type: 'text' },
    { id: 'number', title: 'Número', category: 'field_client', type: 'text' },
    { id: 'neighborhood', title: 'Bairro', category: 'field_client', type: 'text' },
    { id: 'complement', title: 'Complemento', category: 'field_client', type: 'text' },
    { id: 'cep', title: 'CEP', category: 'field_client', type: 'text' },
    { id: 'phone', title: 'Telefone', category: 'field_client', type: 'phone' },
    { id: 'email', title: 'Email', category: 'field_client' },
    { id: 'today', title: 'Data de hoje', category: 'other_field', type: 'date' }
  ],

  tasktemplate_automation_action: [
    { value: 'send_message', text: 'Enviar mensagem' }
  ],

  tasktemplate_automation_type: [
    { value: 1, text: 'Incluir' },
    { value: 2, text: 'Editar' },
    { value: 3, text: 'Deletar' }
  ],

  tasktemplate_automation_fields: [
    { value: 'task_status_id', text: 'Status' }
  ],

  tasktemplate_automation_send_message_type: [
    {value: 'wpp', text: 'WhatsApp'}
    // {value: 'email', text: 'E-mail'}
  ]
}



// WEBPACK FOOTER //
// ./src/translate/pt_br/value.js